
export default {
	props: {
		price: {
			type: [String, Number],
			required: true
		}
	}
}
